import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeInit"] */ "/opt/build/repo/src/components/theme-init.tsx");
